
export { X as Icon } from "./main-UMBqf2Ea.js"